import InputField from '@/components/elements/inputfields/InputField';
import Icon from '@/components/icons/Icon';
import ConfirmationModalView from '@/components/modules/modals/ConfirmationModalView';
import { isNationalId } from '@/helpers/utilsTS';
import { _t } from '@/locale';
import { GiftCardType } from '../../types/types';

const baseTranslation = 'features.giftcard-self-serve.components.modals.ConfirmSendReceipt';

const ConfirmSendReceipt = ({
  isOpen,
  handleSendReceipt,
  onCancel,
  loading,
  giftcardType,
  buyerEmail,
  ssnInput,
  handleClear,
  handleChangeSsn,
}: {
  isOpen: boolean;
  handleSendReceipt: () => void;
  onCancel: () => void;
  loading?: boolean;
  giftcardType: GiftCardType;
  buyerEmail: string;
  ssnInput: {
    value: string;
    error: string;
  };
  handleClear: () => void;
  handleChangeSsn: (value: string) => void;
}) => {
  return (
    <ConfirmationModalView
      isOpen={isOpen}
      title={_t(`features.giftcard-self-serve.GiftcardSelfServe.sendReceiptCta`) + '?'}
      confirmText={_t(`features.giftcard-self-serve.GiftcardSelfServe.sendReceiptCta`)}
      cancelText={_t('abort')}
      isLoading={loading}
      body={
        <>
          <div className="text-m">
            <span className="text-fg_secondary">{_t(`${baseTranslation}.body`)}</span>{' '}
            <span className="font-bold">{buyerEmail}</span>
          </div>
          {giftcardType === 'wellness' && (
            <InputField
              id="ssn"
              label={_t(`${baseTranslation}.ssnInput.label`)}
              placeholder={_t(`${baseTranslation}.ssnInput.placeholder`)}
              value={ssnInput.value}
              rightPadding={false}
              leftPadding={false}
              handleClear={handleClear}
              rightIcon={
                isNationalId(ssnInput.value) && !ssnInput.error && <Icon variant="check" color="fg_positive" />
              }
              error={ssnInput.error}
              onChange={(e) => handleChangeSsn(e.target.value)}
            />
          )}
        </>
      }
      onConfirm={handleSendReceipt}
      onCancel={onCancel}
    />
  );
};

export default ConfirmSendReceipt;
